// Class / subject / chapter chips shared by the Studio session card
// (TeacherDashboard) and the Content Editor header, so both look the same.
export const META_CHIP = 'text-xs px-2 py-0.5 rounded-md bg-slate-100 text-slate-700';
export const MISSING_CHIP = 'text-xs px-2 py-0.5 rounded-md border border-dashed border-slate-300 text-slate-500';
